import { isPlatformBrowser } from '@angular/common';
import { ChangeDetectorRef, Component, effect } from '@angular/core';
import { ChartData, ChartDataset, ChartOptions } from 'chart.js';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrl: './reports.component.scss'
})
export class ReportsComponent {
  
  data: any;

    options: any;

    // platformId = inject(PLATFORM_ID);

    // configService = inject(AppConfigService);

    // designerService = inject(DesignerService);

    constructor(private cd: ChangeDetectorRef) {}

    // themeEffect = effect(() => {
    //     if (this.configService.transitionComplete()) {
    //         if (this.designerService.preset()) {
    //             this.initChart();
    //         }
    //     }
    // });

    ngOnInit() {
        this.initChart();
    }

    initChart() {
     
            const documentStyle = getComputedStyle(document.documentElement);
            const textColor = '#a3a1a1';

            this.data = {
                labels: ['Executed', 'Negotiation', 'Renewal'],
                datasets: [
                    {
                        data: [540, 325, 702],
                        backgroundColor: ['#878e39ff', 'rgba(13, 109, 177, 1)', '#fa2585ff'],
                        hoverBackgroundColor: [documentStyle.getPropertyValue('--p-cyan-400'), documentStyle.getPropertyValue('--p-orange-400'), documentStyle.getPropertyValue('--p-gray-400')]
                    }
                ]
            };

            this.options = {
                plugins: {
                    legend: {
                        labels: {
                            usePointStyle: true,
                            color: textColor
                        }
                    }
                }
            };
            this.cd.markForCheck()
        }
   
    

}
